import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { MdOutlineOilBarrel, MdOutlineQuestionMark, MdOutlineSolarPower } from "react-icons/md";
import { SlEnergy } from "react-icons/sl";
import { TbFlame } from "react-icons/tb";
import { FaCheck } from 'react-icons/fa';
import { TiThMenu } from "react-icons/ti";
import { useAuthState } from "../../context/AuthContext";
import { FaXmark } from "react-icons/fa6";
import { BsGearFill } from "react-icons/bs";
import AreYouSureModal from "../shared/AreYouSureModal";
import PrivateApi from "../../services/PrivateApiService";
import { useQueryClient } from "react-query";
import EnergoTooltip from "../shared/EnergoTooltip";


/**
 * CustomerAnlageCard
 * 
 * Displays information about anlage in current top. Information about anlage 
 * and information about customers Energielieferverträge
 * 
 * is used in pages/customer/UserDashboardPage
 * 
 * @param {props} anlage object anlage
 * @param {props} inCreation optional boolean true if anlage is in creation not existing at moment
 * @param {props} elv object elv. Elv from this Anlage
 * @param {props} ticket object ticket. If the anlage is in creation this will be used as reference
 * @param {props} old optional boolean true if Anlage is old and should be grayed out.
 * @param {props} changeModal function to change Anlage
 * 
 * @returns html anlagecard to be displeyed
 */
const CustomerAnlageCard = ({ anlage, inCreation, elvs, ticket, old, changeModal, switchHandler }) => {

    // initial vars
    const API = new PrivateApi();
    const queryClient = useQueryClient();
    const {user, tooltips, tooltipsTrigger} = useAuthState();
    const [switchBool, setSwitchBool] = useState(false);
    const [sureModal, setSureModal] = useState(false);
    const [yesLoading, setYesLoading] = useState(false);

    // card vars
    var headerBg = "#6c757d"; // header background default is gray
    var icon = <MdOutlineQuestionMark size={30} />; // header icon default is question mark
    var hasSecondZaehler = false;
    var elv = false;

    // change values depending on anlage
    if (anlage.x_studio_field_3eKe0 === "Strom") { headerBg = '#a2c13f'; icon = <SlEnergy size={30} />; }
    if (anlage.x_studio_field_3eKe0 === "Gas") { headerBg = '#3fbfbf'; icon = <TbFlame size={30} />; }
    if (anlage.x_studio_field_3eKe0 === "Oil") { headerBg = '#a2c13f'; icon = <MdOutlineOilBarrel size={30} /> }
    if (anlage.x_studio_field_3eKe0 === "Strom-Einspeisung") { headerBg = '#ffc107'; icon = <MdOutlineSolarPower size={30} />; }
    if (old) headerBg = "#6b6b6b";
    if (anlage.x_zaehlernummer_02 !== "" && anlage.x_zaehlernummer_02 !== "False") hasSecondZaehler = true;
    
    var filteredElvs = elvs? elvs.filter(e => anlage.x_elv_ids.length > 0 && anlage.x_elv_ids.includes(e.id) && e.x_kunde_id[0] === user.id): false;
    if (filteredElvs && filteredElvs.length > 0) {
        elv = filteredElvs.filter(f => f.x_datum_vertragsende === "False" || new Date(f.x_datum_vertragsende) > new Date())[0];
    }
    
    
    useEffect(() => {
        if (elv !== undefined) {
            if (elv.x_kunde_id && elv.x_kunde_id[0] === user.id) {
                setSwitchBool(true);
            }
        }
    }, [elv])



    const closeTicketHandler = () => {
        setYesLoading(true);
        var data = {ticket_id: ticket[0].id, user: user};
        API.post_Ticket_close(data)
            .then(() => {
                queryClient.invalidateQueries("CLIENT_GET_ANLAGEN");
                setYesLoading(false);
                setSureModal(false);
            });
    }
    


    // GUI
    return (
        <Card className="mt-3 mb-5 shadow-lg rounded text-start">
            <Card.Header className="text-white" style={inCreation || old ? { opacity: 0.4, backgroundColor: headerBg } : { backgroundColor: headerBg }}>
                <div className="border border-2 rounded-circle energo-card-header-icon">
                    {icon}
                </div>
                <div className="adjust-font-on-small energo-card-header-icon-text">
                    {anlage.x_studio_field_3eKe0}
                </div>
                <div hidden={anlage.x_studio_field_mWMGR === "new" || anlage.x_studio_field_mWMGR === "False"} className="energo-card-header-action">
                    <button className="btn btn-link text-white" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                        <TiThMenu className="text-warning" size={30} />
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                        <li key={"edit"} className="text-center">
                            <a onClick={e => { e.preventDefault(); changeModal(anlage) }} href="/anlage/ändern/" className="link-energo">Ändern / Frage</a>
                        </li>
                    </ul>
                </div>
                <div style={{ float: "right", paddingTop: "5px" }}>
                    <span style={{ fontSize: "30px", fontWeight: "300" }}>{anlage.x_studio_field_mWMGR}</span>
                </div>
                <div className="hide-on-small" style={{ display: "inline-block", float: "right", paddingTop: "16px" }}>
                    <span>Anlagennummer ENERGO: &nbsp;</span>
                </div>
            </Card.Header>
            <Card.Body style={old? {opacity: 0.6}:null}>
                <Row className=" mt-3">
                    <Col xl="8" style={inCreation? {opacity: 0.4}: null}>
                        <p>Anlagenadresse &nbsp; <small className="text-muted">{anlage.x_adresse_kompakt}</small></p>
                        {anlage.x_anlagenverwendung !== "False" && anlage.x_anlagenverwendung !== "" ?
                            <p>Anlagenverwendung &nbsp; <small className="text-muted">{anlage.x_anlagenverwendung}&nbsp;
                            {anlage.x_anlagenverwendung_detail && anlage.x_anlagenverwendung_detail !== "False" && anlage.x_anlagenverwendung_detail !== "" && anlage.x_anlagenverwendung_detail !== anlage.x_anlagenverwendung && `(${anlage.x_anlagenverwendung_detail})`}</small></p>
                            : null
                        }

                        {!hasSecondZaehler?
                            <>
                            <p>Zählernummer &nbsp; <small className="text-muted">{anlage.x_zaehlernummer_01}</small></p>
                            <p>Zählpunktnummer &nbsp; <small className="text-muted">{anlage.x_zaehlpunktnummer_01}</small></p>
                            {anlage.x_lastprofil_01 !== "False" ?
                                <p>Lastprofil &nbsp; <small className="text-muted">{anlage.x_lastprofil_01}</small></p> : null
                            }
                            {anlage.x_is_smartmeter_01 !== undefined || anlage.x_is_smartmeter_01 !== "False" ? 
                                <p>Smartmeter &nbsp; <small>{anlage.x_is_smartmeter_01 === true? <FaCheck className="text-energo" />: <FaXmark className="text-danger" />}</small></p>
                                :null
                            }
                            </>
                            :null
                        }
                    </Col>
                    <Col xl="4" className="text-center">
                        <p className="text-muted">
                            {
                                ticket && ticket.length > 0 ?
                                    ticket[0].ticket_type_id[0] === 15 ? 'Anmeldung im Gange' :
                                        ticket[0].ticket_type_id[0] === 16 ? 'Abmeldung im Gange' :
                                            ticket[0].ticket_type_id[0] === 17 ? 'Anlage wird hinzugefügt' : null
                                    :
                                    switchBool === true?
                                        'Anlage angemeldet':
                                        'Anlage abgemeldet'
                            }
                        </p>
                        <div 
                            style={{
                                display: "flex", 
                                alignItems: "center", 
                                justifyContent: "center"
                            }} 
                            hidden={(ticket !== undefined && ticket.length > 0) || switchBool === false || old}>
                            <Form.Check
                                id={`switch-${anlage.id}`}
                                className="switch-energo"
                                style={{marginRight: "10px"}}
                                type="switch"
                                defaultChecked={!switchBool}
                                onChange={e => {switchHandler(anlage); setSwitchBool(!e.target.checked)}}
                            />
                            <EnergoTooltip tKey="2001" position="right" />
                        </div>
                        {ticket !== undefined && ticket.length > 0?
                            <>
                                <div style={{display: "flex", justifyContent: "center", marginBottom: 10}}>
                                    <BsGearFill size={40} style={{marginTop: -8, marginRight: 10}} className="text-energo rotating" />
                                    <EnergoTooltip tKey={ticket[0] === 16 ? "2003": "2002"} position="right" />
                                </div>
                                <Button onClick={() => setSureModal(true)} style={{marginBottom: 10}} variant="danger">Abbrechen</Button>
                                <AreYouSureModal
                                    show={sureModal}
                                    setShow={setSureModal}
                                    title="Aktion abbrechen"
                                    message="Sind Sie sicher, dass Sie diese Aktion abbrechen wollen?"
                                    loading={yesLoading}
                                    yesHandler={closeTicketHandler}
                                />
                            </>
                        :null}

                        {switchBool === true ?
                            <>
                                <br />
                                <a href={`/dashboard/energieliefervertraege/${elv.id}`} className="link-energo">Energieliefervertrag ansehen</a>
                            </>
                        :null}
                    </Col>
                </Row>
                <Row className="mt-5" style={inCreation || old ? {opacity: 0.4}:null}>
                    {hasSecondZaehler?
                        <Col className={hasSecondZaehler ? 'border-right': null} xs="12" md={hasSecondZaehler? "6": "12"} xl={hasSecondZaehler ? "6": "12"}>
                            <p className="text-center">Zählpunkt 1</p>
                            <p>Zählernummer &nbsp; <small className="text-muted">{anlage.x_zaehlernummer_01}</small></p>
                            <p>Zählpunktnummer &nbsp; <small className="text-muted">{anlage.x_zaehlpunktnummer_01}</small></p>
                            {anlage.x_lastprofil_01 !== "False"?
                                <p>Lastprofil &nbsp; <small className="text-muted">{anlage.x_lastprofil_01}</small></p>
                            :null}
                            {anlage.x_is_smartmeter_01 !== undefined || anlage.x_is_smartmeter_01 !== "False" ? 
                                <p>Smartmeter &nbsp; <small>{anlage.x_is_smartmeter_01 === true? <FaCheck className="text-energo" />: <FaXmark className="text-danger" />}</small></p>
                                :null
                            }
                        </Col>
                    :null}
                    {hasSecondZaehler?
                        <Col xs="12" md="6" xl="6">
                            <p className="text-center">Zählpunkt 2</p>
                            <p>Zählernummer &nbsp; <small className="text-muted">{anlage.x_zaehlernummer_02}</small></p>
                            <p>Zählpunktnummer &nbsp; <small className="text-muted">{anlage.x_zaehlpunktnummer_02}</small></p>
                            {anlage.x_lastprofil_02 !== "False"?
                                <p>Lastprofil &nbsp; <small className="text-muted">{anlage.x_lastprofil_02}</small></p>
                            :null}
                            {anlage.x_is_smartmeter_02 !== undefined || anlage.x_is_smartmeter_02 !== "False" ? 
                                <p>Smartmeter &nbsp; <small>{anlage.x_is_smartmeter_01 === true? <FaCheck className="text-energo" />: <FaXmark className="text-danger" />}</small></p>
                                :null
                            }
                        </Col>
                    :null}

                </Row>
                
            </Card.Body>
        </Card>
    )
}

export default CustomerAnlageCard;